import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, FieldArray, arrayPush, change } from 'redux-form';

import withFeatureFlags from 'hocs/withFeatureFlags';
import ListImage from './ListImage';
import styles from './Media.css';

class Media extends React.Component {
  constructor() {
    super();
    this.state = {
      prevId: null,
      errors: false,
      errorMessage: '',
      dimensionImage: {},
    };
  }

  componentDidUpdate(prevProps) {
    const { itemDetail } = this.props;
    if (
      (prevProps.itemDetail && this.state.prevId !== prevProps.itemDetail.id) ||
      (itemDetail &&
        prevProps.itemDetail &&
        itemDetail.id !== prevProps.itemDetail.id)
    ) {
      this.setState({
        errors: false,
        errorMessage: '',
        prevId: itemDetail.id,
      });
    }
  }

  getImageValue = (url, cb) => {
    // initiate the Image
    const image = new Image();
    image.src = url;

    // get value width and height
    image.onload = function() {
      const dimensionImage = {
        width: this.width,
        height: this.height,
      };
      cb(dimensionImage);
    };
  };

  validateDimension = dimensionImage => {
    const {
      itemForm: { images },
      enableAspectRatioImageEcommerce,
    } = this.props;
    const { width, height } = dimensionImage;
    const isCorrectFormat = enableAspectRatioImageEcommerce
      ? width >= 500 && height >= 500
      : width >= 1024 && height >= 1024;

    if (!isCorrectFormat) {
      const errorMessage = enableAspectRatioImageEcommerce
        ? 'Failed to upload image. Min size required is <strong>500x500px</strong>, max <strong>8MB</strong>'
        : 'Failed to upload image. Min size required is <strong>1024x1024px</strong>, max <strong>8MB</strong>';
      this.setState({
        errors: true,
        errorMessage,
      });
      this.handleDelete(images.length - 1);
    }
  };

  handleChange = e => {
    const file = e.target.files[0];
    const reader = new FileReader();
    const { dispatch, enableAspectRatioImageEcommerce } = this.props;
    const fileTypes = ['image/bmp', 'image/jpeg', 'image/png'];
    reader.onload = e => {
      this.getImageValue(e.target.result, this.validateDimension);
      if (!fileTypes.includes(file.type)) {
        this.setState({
          errors: true,
          errorMessage:
            'Failed to upload images. Please upload images with valid format',
        });
        return;
      }
      if (file.size >= 8388608) {
        const errorMessage = enableAspectRatioImageEcommerce
          ? 'Failed to upload image. Min size required is <strong>500x500px</strong>, max <strong>8MB</strong>'
          : 'Failed to upload image. Min size required is <strong>1024x1024px</strong>, max <strong>8MB</strong>';
        this.setState({
          errors: true,
          errorMessage,
        });
      } else {
        this.setState({
          errors: false,
        });
        dispatch(
          arrayPush('item', 'images', {
            file_name: file.name,
            raw_image_url: reader.result,
          })
        );
      }
    };
    e.target.value = null;
    reader.readAsDataURL(file);
  };

  handleDelete = index => {
    const {
      dispatch,
      itemForm: { images },
    } = this.props;
    images.splice(index, 1);
    dispatch(change('item', 'images', images));
  };

  render() {
    const { errors, errorMessage } = this.state;
    const {
      itemForm,
      itemDetail,
      enableAspectRatioImageEcommerce,
    } = this.props;

    return (
      <div className="form-group">
        <div className={styles['subtitle-container']}>
          <span className={styles.subtitle}>
            Add up to <strong> 12 photos </strong>. Size min{' '}
            <strong>
              {enableAspectRatioImageEcommerce ? '500x500px' : '1024x1024px'}
            </strong>
            and max <strong>8MB</strong>. Format: PNG, JPEG, BMP.
          </span>
        </div>
        {errors && (
          <div className={styles['error-container']}>
            <span dangerouslySetInnerHTML={{ __html: errorMessage }} />
          </div>
        )}
        {itemForm.images.length > 0 ? (
          <FieldArray
            name="images"
            component={ListImage}
            images={itemForm.images}
            itemDetail={itemDetail}
            handleDelete={this.handleDelete}
            handleUpload={this.handleChange}
          />
        ) : (
          <div className={styles['upload-container']}>
            <label className={styles['label-upload']}>
              Upload File
              <input
                type="file"
                accept=".jpg, .jpeg, .png, .bmp"
                onChange={this.handleChange}
              />
            </label>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { itemDetail } = state.library.item;
  return {
    itemDetail,
    itemForm: getFormValues('item')(state),
  };
};

const connected = connect(mapStateToProps)(Media);

function mapFeatureFlags(flags) {
  return {
    enableAspectRatioImageEcommerce: flags.enableAspectRatioImageEcommerce,
  };
}

export default withFeatureFlags(mapFeatureFlags)(connected);
